import { defineMessages } from 'react-intl';

export default defineMessages({
  logoAltText: {
    id: 'donations.plus.logo.altText',
    defaultMessage: 'Donations Plus Logo',
  },
});
